export default __webpack_public_path__ + "static/media/shawl.072fae1b.svg";